(() => {
  const cfg = window.PHRemateSettings || {};
  const body = document.body;
  if (!body) return;

  const excludedPath = location.pathname === '/pages/ph-negocios' || location.pathname.startsWith('/pages/ph-negocios/');
  const parse = value => {
    const t = Date.parse(value || '');
    return Number.isFinite(t) ? t : null;
  };
  const start = parse(cfg.start);
  const end = parse(cfg.end);

  function isActive() {
    if (!cfg.enabled || excludedPath || start === null || end === null || end <= start) return false;
    const now = Date.now();
    return now >= start && now <= end;
  }

  function setState() {
    const active = isActive();
    body.classList.toggle('ph-theme-remate', active);
    body.dataset.phRemate = active ? 'active' : 'inactive';
    document.querySelectorAll('[data-ph-remate-block]').forEach(block => { block.hidden = !active; });
    document.dispatchEvent(new CustomEvent('ph:remate:update', { detail: { active, start, end } }));
    return active;
  }

  function updateClock() {
    const blocks = document.querySelectorAll('[data-ph-remate-block]');
    if (!blocks.length || !setState()) return;
    const remaining = Math.max(0, end - Date.now());
    const sec = Math.floor(remaining / 1000);
    const days = Math.floor(sec / 86400);
    const hours = Math.floor((sec % 86400) / 3600);
    const mins = Math.floor((sec % 3600) / 60);
    const secs = sec % 60;
    const pad = n => String(n).padStart(2, '0');
    const map = { days, hours, minutes: mins, seconds: secs };
    blocks.forEach(block => {
      Object.entries(map).forEach(([key,val]) => {
        const node = block.querySelector(`[data-${key}]`);
        if (node) node.textContent = pad(val);
      });
    });
  }

  setState();
  updateClock();
  window.setInterval(updateClock, 1000);
})();
